"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const PAYMENT_STATUS_1 = __importDefault(require("../../../constants/payment/PAYMENT_STATUS"));
const PAYMENT_STATUS_POLL_DELAY_1 = __importDefault(require("../../../constants/payment/PAYMENT_STATUS_POLL_DELAY"));
const PAYMENT_STATUS_POLL_TRY_1 = __importDefault(require("../../../constants/payment/PAYMENT_STATUS_POLL_TRY"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
const getSessionToken_1 = __importDefault(require("../../../utils/login/getSessionToken"));
const getPaymentToken_1 = __importDefault(require("../../../utils/payment/getPaymentToken"));
/**
 * Client interface to make payment status API call
 * Will be called by 3d secure payment flow
 * @param {PaymentStatusParamType} reqParam
 * @returns {Promise}
 */
let statusPollCount = 0;
const paymentStatus = (reqParam) => __awaiter(void 0, void 0, void 0, function* () {
    const requestId = `PAYMENT_STATUS_${Date.now()}`;
    statusPollCount += 1;
    // for payment status the quoteID (that comes in req param body) never expires
    // its a mere reference number for the booking
    // JWT token is mandatory (Authenticated API)
    // for logged in user pass login cookie token
    // for non logged in user pass token got from /payment/checkout call
    const token = (0, getSessionToken_1.default)() || (0, getPaymentToken_1.default)();
    // if token present then add to header
    // or else let api throw 401 error
    const config = {
        data: reqParam,
    };
    if (token) {
        config.headers = {
            Authorization: `Bearer ${token}`,
        };
    }
    const responseData = yield http_service_1.default
        .post(requestId, ENDPOINTS_1.default.BOOKING_SERVICE.PAYMENT_STATUS, config)
        .then((response) => response.data);
    console.log('status: ', responseData, statusPollCount);
    // get status
    const status = (0, get_1.default)(responseData, 'status', '');
    // we got success or failed
    // return back to store
    if (status === PAYMENT_STATUS_1.default.SUCCESS || status === PAYMENT_STATUS_1.default.FAILED) {
        return Promise.resolve(responseData);
    }
    // pending
    // call again after delay
    // add delay in between requests
    yield new Promise((resolve) => {
        setTimeout(resolve, PAYMENT_STATUS_POLL_DELAY_1.default);
    });
    console.log('payment status fake delay over');
    if (statusPollCount <= PAYMENT_STATUS_POLL_TRY_1.default) {
        return paymentStatus(reqParam);
    }
    console.log('long poll end');
    return Promise.resolve({
        status: PAYMENT_STATUS_1.default.TIMED_OUT,
        card: '',
        scheme: '',
    });
});
exports.default = paymentStatus;
